module.exports = __webpack_public_path__ + "static/media/tuna-lid.5d87c596.png";